// @flow
/** ****************************************************************************
*   @author mbarbosa (mbarbosa@mobinteg.com)
*   @author Afonso Bordado (abordado@mobinteg.com)
*******************************************************************************/

import React, { Component } from "react"
import styles from "./styles.css"
import { connect } from "react-redux"
import Card from "../Card"
import Spacer from "../Spacer"
import SimpleTable from "../SimpleTable"
import SectionSeparator from "../SectionSeparator"
import Input from "react-toolbox/lib/input"
import Dropdown from "react-toolbox/lib/dropdown/Dropdown"
import Dialog from "react-toolbox/lib/dialog"
import Chip from "react-toolbox/lib/chip"
import * as strings from "../../strings"
import Button from "react-toolbox/lib/button"
import _ from "lodash"
import { withRouter } from "react-router-dom"
import { toastr } from "react-redux-toastr"
import { formatDate, formatCurrency, translationFunction } from "../../utils"
import { scheduleJob } from "../../actions"
import DatePicker from "../../components/DatePicker"
import FontIcon from "react-toolbox/lib/font_icon/FontIcon"
import Checkbox from "react-toolbox/lib/checkbox"

const PUBLIC_EXECUTION_COLUMNS = {
  debtValue: { title: strings.paymentAgreements.debtValue, align: "left" },
  reason: { title: strings.publicLists.reason, align: "left" },
  extinctionDate: { title: strings.publicLists.extinctionDate, align: "left" },
  inclusionDate: { title: strings.publicLists.inclusionDate, align: "left" },
  section: { title: strings.paymentAgreements.section, align: "left" },
  court: { title: strings.paymentAgreements.court, align: "left" },
  executionAgent: { title: strings.paymentAgreements.executionAgent, align: "left" },
  executionNumber: { title: strings.paymentAgreements.executionNumber, align: "left" },
}

const PUBLIC_INSOLVENCIES_COLUMNS = {
  act: { title: strings.publicLists.act, align: "left" },
  reference: { title: strings.publicLists.reference, align: "left" },
  insolvencyNumber: { title: strings.publicLists.insolvencyNumber, align: "left" },

  date: { title: strings.generalStrings.date, align: "left" },

  court: { title: strings.paymentAgreements.court, align: "left" },
  type: { title: strings.publicLists.type, align: "left" },
  insolvencyAdministratorName: { title: strings.publicLists.insolvencyAdministrator, align: "left" },
}

export const DebtorEdit = withRouter( class DebtorEdit extends Component {
  props: {
    debtId: any,
    debtor: any,
    editable: boolean,
    onDelete: () => any,
    title: string,
    documentType: any,
    onChange: () => any,
    isMainDebtor: boolean,
    history: {
      push: () => {}
    },
    scheduleJob: () => any,
  }

  state = {
    isShowingLPE: false,
    isShowingPIL: false,
  }

  handleContactUpdate = name => value => this.props.onChange && this.props.onChange( {
    ...this.props.debtor,
    contact: {
      ...this.props.debtor.contact,
      [ name ]: value,
    },
  } )

  handleDebtorUpdate = name => value => this.props.onChange && this.props.onChange( {
    ...this.props.debtor,
    [ name ]: value,
  } )

  handleDeleteDebtor = debtor => () => this.props.onDelete && this.props.onDelete( debtor )

  toggleForm = formName => () => this.setState( {
    [ formName ]: !this.state[ formName ],
  } )

  renderBottomRow ( debtor ) {
    const { contact } = debtor
    const { publicExecutions, publicInsolvencies } = contact
    const publicExecs = publicExecutions || []
    const publicInsols = publicInsolvencies || []
    return (
      <div className={styles.debtorBottomRow}>
        <div className={styles.publicListsWrapper}>
          <Chip onClick={this.toggleForm( "isShowingLPE" )} style={{ cursor: "pointer" }}>
            {publicExecs.length}
            {publicExecs.length !== 1 ? " entradas " : " entrada "}
            na lista pública de execuções
          </Chip>
          <Spacer size={1}/>
          <Chip onClick={this.toggleForm( "isShowingPIL" )} style={{ cursor: "pointer" }}>
            {publicInsols.length}
            {publicInsols.length !== 1 ? " entradas " : " entrada "}
            na lista PER/PEAP/insolvência
          </Chip>
          <Spacer size={2}/>
          <Checkbox
            label={strings.generalStrings.ignoreNotifications}
            checked={debtor.ignoreNotifications}
            onChange={a => { this.handleDebtorUpdate("ignoreNotifications")(a) }}
          />
        </div>
      </div>
    )
  }

  scheduleExecutionListUpdate = debtor => () => this.props.scheduleJob( "ExecutionListUpdate", {
    nifList: [ debtor.contact.nif ],
  } ).then( ( result ) => {
    if ( result.message ) {
      toastr.error( result.message )
      return
    }
    toastr.success( "Pesquisa agendada" )
    this.setState( {
      isShowingLPE: false,
      isShowingPIL: false,
    } )
  } ).catch( () => {
    toastr.error( "Erro a agendar pesquisa" )
  } )


  scheduleScraper = ( debtor, type ) => () => this.props.scheduleJob( "CitiusJob", {
    type,
    nifList: [ debtor.contact.nif ],
  } ).then( ( result ) => {
    if ( result.message ) {
      toastr.error( result.message )
      return
    }
    toastr.success( "Pesquisa agendada" )
    this.setState( {
      isShowingLPE: false,
      isShowingPIL: false,
    } )
  } ).catch( () => {
    toastr.error( "Erro a agendar pesquisa" )
  } )

  renderDialogs = debtor => {
    const { contact } = debtor
    const buttonsDisabled = !contact.nif
    return (
      <div>
        <Dialog
          actions={[
            {
              label: buttonsDisabled ? strings.publicLists.contactHasNoNIF : strings.publicLists.scheduleNewSearch,
              onClick: this.scheduleExecutionListUpdate( debtor ),
              disabled: buttonsDisabled,
            },
            { label: strings.generalStrings.cancel, onClick: this.toggleForm( "isShowingLPE" ) },
          ]}
          active={this.state.isShowingLPE}
          onEscKeyDown={this.toggleForm( "isShowingLPE" )}
          onOverlayClick={this.toggleForm( "isShowingLPE" )}
          type="large"
          title={strings.publicLists.publicExecutions}
        >
          <div className={styles.simpleTableWrapper}>
            <SimpleTable columns={PUBLIC_EXECUTION_COLUMNS} data={( contact.publicExecutions || [] ).map( publicExecution => ( {
              ...publicExecution,
              inclusionDate: formatDate( publicExecution.inclusionDate ),
              extinctionDate: formatDate( publicExecution.extinctionDate ),
              debtValue: formatCurrency( publicExecution.debtValue ),
            } ) )} />
          </div>
        </Dialog>
        <Dialog
          actions={[
            {
              label: buttonsDisabled ? strings.publicLists.contactHasNoNIF : strings.publicLists.scheduleNewSearch,
              onClick: this.scheduleScraper( debtor, "InsolvencyListUpdate" ),
              disabled: buttonsDisabled,
            },
            { label: strings.generalStrings.cancel, onClick: this.toggleForm( "isShowingPIL" ) },
          ]}
          active={this.state.isShowingPIL}
          onEscKeyDown={this.toggleForm( "isShowingPIL" )}
          onOverlayClick={this.toggleForm( "isShowingPIL" )}
          type="large"
          title={strings.publicLists.publicInsolvencies}
        >
          <div className={styles.simpleTableWrapper}>
            <SimpleTable columns={PUBLIC_INSOLVENCIES_COLUMNS} data={( contact.publicInsolvencies || [] ).map( publicInsolvency => ( {
              ...publicInsolvency,
              date: formatDate( publicInsolvency.date ),
            } ) )} />
          </div>
        </Dialog>
      </div>
    )
  }

  render () {
    const { debtor, title, documentType } = this.props
    if ( !debtor || !documentType ) {
      return <div/>
    }
    const { contact } = debtor

    // const errorMessage = strings.errorMessages.invalidField
    // const emailValidation = /^.+@.+$/
    // error={emailValidation.test( contact.email ) ? false : errorMessage} // Left it commented if we want to use it in the future

    const documentTypeSource = documentType.map( documentType => ( {
      value: documentType.name, label: translationFunction( documentType.name ),
    } ) )

    return (
      <div className={styles.padding}>
        {title ? <SectionSeparator title={title}/> : <div />}
        <div className={styles.grid}>
          <Input
            label={strings.generalStrings.name}
            value={contact.name || ""}
            type="text"
            onChange={this.handleContactUpdate( "name" )}
            maxLength={250}
          />
          <Input
            label={strings.generalStrings.email}
            value={contact.email || ""}
            type="text"
            onChange={this.handleContactUpdate( "email" )}
            maxLength={254}
          />
          <Input
            label={strings.debtor.countryCode}
            value={contact.countryCode || ""}
            type="text"
            onChange={this.handleContactUpdate( "countryCode" )}
            maxLength={4}
          />
          <Input
            label={strings.generalStrings.nif}
            value={contact.nif || ""}
            type="text"
            onChange={this.handleContactUpdate( "nif" )}
            maxLength={25}
          />
          <Input
            label={strings.generalStrings.accountNumber}
            value={debtor.accountNumber || ""}
            onChange={this.handleDebtorUpdate( "accountNumber" )}
            type="text"
          />
          <Input
            label="PN"
            value={debtor.pn || ""}
            onChange={this.handleDebtorUpdate( "pn" )}
            type="text"
          />
          <Dropdown
            auto
            label={strings.generalStrings.debtorType}
            source={[
              { value: false, label: strings.paymentAgreements.singular },
              { value: true, label: strings.paymentAgreements.collective },
            ]}
            value={debtor.isCollective}
            onChange={this.handleDebtorUpdate( "isCollective" )}
          />
          <Input
            label={strings.debtor.address}
            value={contact.address || ""}
            type="text"
            onChange={this.handleContactUpdate( "address" )}
            maxLength={254}
          />
          <Input
            title="Cidade"
            label={strings.generalStrings.city}
            value={contact.city || ""}
            type="text"
            onChange={this.handleContactUpdate( "city" )}
            maxLength={100}
          />
          <Input
            label={strings.debtor.zipCode }
            value={contact.zipCode || ""}
            type="text"
            onChange={this.handleContactUpdate( "zipCode" )}
            maxLength={10}
          />
          <Input
            label={strings.debtor.phone}
            value={contact.phone || ""}
            type="text"
            onChange={this.handleContactUpdate( "phone" )}
            maxLength={50}
          />
          <Dropdown
            auto
            label={strings.generalStrings.documentType}
            source={documentTypeSource}
            value={debtor.contact.documentType}
            onChange={this.handleContactUpdate( "documentType" )}
          />
          <DatePicker
            value={contact.documentExpiryDate ? new Date( contact.documentExpiryDate ) : contact.documentExpiryDate}
            onChange={this.handleContactUpdate( "documentExpiryDate" )}
            label={strings.generalStrings.documentExpiryDate}
          />
          <Input
            label={strings.generalStrings.documentNumber}
            value={contact.documentNumber || ""}
            type="text"
            onChange={this.handleContactUpdate( "documentNumber" )}
            maxLength={50}
          />
          <Input
            label={strings.generalStrings.documentCode}
            value={contact.documentCode || ""}
            type="text"
            onChange={this.handleContactUpdate( "documentCode" )}
            maxLength={50}
          />
          <Input
            label={strings.debtor.capitalStock}
            value={contact.capitalStock || ""}
            type="text"
            onChange={this.handleContactUpdate( "capitalStock" )}
            maxLength={50}
          />
          <div>
            {this.props.onDelete ? <FontIcon value="delete" style={{ cursor: "pointer", color: "#777777" }}
              onClick={this.handleDeleteDebtor( debtor )} /> : <div/>}
          </div>
        </div>
        {this.renderBottomRow( debtor )}
        {this.renderDialogs( debtor )}
      </div>
    )
  }
} )


class DebtPhaseDebtors extends Component {
  props: {
    debtors: any[],
    mainDebtorId: number,
    suggestions: any,
    upperState: any,
    onChangeMainDebtor: () => any,
    debtId: any,
    onChange: ( any[] ) => any,
    onDelete: () => any,
    expanded?: boolean,
    onToggle?: () => any,
    changeRepresentantOrGuarantor: () => any,
    scheduleJob: () => any,
  }

  handleChange = debtorId => newValue => {
    this.props.onChange( [
      ...this.props.debtors.filter( debtor => debtor.id !== debtorId ),
      newValue,
    ] )
  }

  renderMainDebtor = debtor => (
    <DebtorEdit
      debtId={this.props.debtId}
      debtor={debtor}
      editable={false}
      onChange={this.handleChange( debtor.id )}
      title={strings.debtor.mainDebtor}
      scheduleJob={this.props.scheduleJob}
      documentType={this.props.suggestions.DocumentTypeEnum}
      isMainDebtor={true}
    />
  )

  renderExtraDebtors = debtors => debtors.map( ( debtor, index ) => (
    <div key={debtor.id}>
      <DebtorEdit
        debtId={this.props.debtId}
        debtor={debtor}
        onChange={this.handleChange( debtor.id )}
        editable
        title={index === 0 ? strings.debtor.otherDebtors : ""}
        scheduleJob={this.props.scheduleJob}
        documentType={this.props.suggestions.DocumentTypeEnum}
        onDelete={this.props.onDelete}
        isMainDebtor={false}

      />
    </div>
  ) )

  renderNewDebtor = ( newDebtor = undefined ) => {
    if ( newDebtor !== undefined ) {
      return (
        <DebtorEdit
          debtor={newDebtor}
          onChange={this.handleChange( undefined )}
          title="Novo Devedor"
          scheduleJob={this.props.scheduleJob}
          documentType={this.props.suggestions.DocumentTypeEnum}
          onDelete={this.props.onDelete}
          isMainDebtor={false}
        />
      )
    } else {
      return (
        <div className={styles.buttonWrapper}>
          <Button onClick={this.addNewDebtor} icon="add" raised primary>Adicionar Devedor</Button>
        </div>
      )
    }
  }

  addNewDebtor = ( ) => {
    const newDebtor = {
      accountNumber: undefined,
      pn: undefined,
      isRepresentant: undefined,
      contact: {
        address: undefined,
        cc: undefined,
        city: undefined,
        email: undefined,
        id: undefined,
        name: undefined,
        nif: undefined,
        phone: undefined,
        zipCode: undefined,
        ccCode: undefined,
        ccExpiryDate: undefined,
      },
      id: undefined,
    }

    this.props.onChange( [
      ...this.props.debtors,
      newDebtor,
    ] )
  }

  render () {
    const { mainDebtorId, debtors } = this.props

    const mainDebtor = debtors.find( debtor => debtor.id === mainDebtorId )
    const newDebtor = debtors.find( debtor => debtor.id === undefined )
    const filteredDebtors = debtors.filter( debtor => debtor.id !== mainDebtorId && debtor.id !== undefined )
    const sortedDebtors = _.sortBy( filteredDebtors, "id" )

    let debtorsSource = []
    this.props.upperState.debtorsInfo.debtDebtors.forEach( debtDebtor => {
      if ( debtDebtor.debtor.id ) {
        debtorsSource = [ ...debtorsSource, { value: debtDebtor.debtor.id, label: debtDebtor.debtor.contact.name } ]
      }
    } )

    const representant = this.props.upperState.debtorsInfo.debtDebtors
      .find( debtDebtor => debtDebtor.debtor.isRepresentant )
    const guarantor = this.props.upperState.debtorsInfo.debtDebtors
      .find( debtDebtor => debtDebtor.debtor.isGuarantor )
    const guarantorRepresentant = this.props.upperState.debtorsInfo.debtDebtors
      .find( debtDebtor => debtDebtor.debtor.isGuarantorRepresentant )
    const isRepresentantDisabled = mainDebtor ? !mainDebtor.isCollective : true
    const isGuarantorRepresentantDisabled = guarantor ? !guarantor.debtor.isCollective : true
    return (
      <div>
        <Card className={styles.padding}>

          <div className={styles.dropDowns}>
            <Dropdown
              auto
              label={strings.generalStrings.mainDebtor}
              source={debtorsSource}
              value={this.props.upperState.debtorsInfo.idDebtor}
              onChange={( value ) => this.props.onChangeMainDebtor( value )}
            />
            <Dropdown
              auto
              label={strings.generalStrings.representant}
              source={debtorsSource}
              value={ representant && !isRepresentantDisabled ? representant.debtor.id : undefined }
              onChange={( value ) => this.props.changeRepresentantOrGuarantor( value, "isRepresentant" )}
              disabled={isRepresentantDisabled}
            />
            <Dropdown
              auto
              label={strings.generalStrings.guarantor}
              source={debtorsSource}
              value={ guarantor ? guarantor.debtor.id : undefined }
              onChange={( value ) => this.props.changeRepresentantOrGuarantor( value, "isGuarantor" )}
            />
            <Dropdown
              auto
              label={"Representante fiador"}
              source={debtorsSource}
              value={ guarantorRepresentant && !isGuarantorRepresentantDisabled ? guarantorRepresentant.debtor.id : undefined }
              onChange={( value ) => this.props.changeRepresentantOrGuarantor( value, "isGuarantorRepresentant" )}
              disabled={isGuarantorRepresentantDisabled}
            />
          </div>
          {this.renderMainDebtor( mainDebtor )}

          {sortedDebtors.length ? this.renderExtraDebtors( sortedDebtors ) : <div/>}

          {this.renderNewDebtor( newDebtor )}
        </Card>
      </div>
    )
  }
}

export default connect( store => ( { suggestions: store.suggestions } ), { scheduleJob } )( DebtPhaseDebtors )



// WEBPACK FOOTER //
// ./src/components/DebtPhaseDebtors/index.jsx